export default class MarivaEffects {
  constructor() {
    this.body = document.body;
    if (!this.body.classList.contains("theme-mariva_midnight")) return;

    this.header = document.querySelector(".header");
    this.logo = document.querySelector(".header__logo");
    this.hero = document.querySelector(".mariva-hero");
    this.revealTargets = Array.from(
      document.querySelectorAll(".about-reborn, .projects, .section--references, .home-blog, .contact"),
    );
    this.floatTargets = Array.from(document.querySelectorAll(".mariva-float"));
    this.parallaxTargets = Array.from(document.querySelectorAll(".mariva-parallax"));

    this.onScroll = this.onScroll.bind(this);
    this.onLogoMove = this.onLogoMove.bind(this);
    this.onLogoLeave = this.onLogoLeave.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);

    this.setupScrollState();
    this.setupLogoGlow();
    this.setupRevealObserver();
    this.setupSubtleMotion();
  }

  setupScrollState() {
    this.onScroll();
    window.addEventListener("scroll", this.onScroll, { passive: true });
  }

  onScroll() {
    const scrolled = window.scrollY > 22;
    this.body.classList.toggle("mariva-scrolled", scrolled);
    if (this.hero) {
      this.hero.classList.toggle("mariva-hero--compressed", window.scrollY > 90);
    }
    this.updateParallax();
  }

  setupLogoGlow() {
    if (!this.logo) return;
    this.logo.style.setProperty("--mx", "50%");
    this.logo.style.setProperty("--my", "50%");
    this.logo.addEventListener("mousemove", this.onLogoMove);
    this.logo.addEventListener("mouseleave", this.onLogoLeave);
  }

  onLogoMove(event) {
    if (!this.logo) return;
    const rect = this.logo.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;
    this.logo.style.setProperty("--mx", `${Math.max(0, Math.min(100, x))}%`);
    this.logo.style.setProperty("--my", `${Math.max(0, Math.min(100, y))}%`);
  }

  onLogoLeave() {
    if (!this.logo) return;
    this.logo.style.setProperty("--mx", "50%");
    this.logo.style.setProperty("--my", "50%");
  }

  setupRevealObserver() {
    if (!("IntersectionObserver" in window) || !this.revealTargets.length) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mariva-revealed");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -12% 0px" },
    );

    this.revealTargets.forEach((el, index) => {
      el.style.setProperty("--reveal-delay", `${Math.min(index * 55, 260)}ms`);
      el.classList.add("mariva-reveal");
      observer.observe(el);
    });
  }

  setupSubtleMotion() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    if (this.floatTargets.length) {
      window.addEventListener("pointermove", this.onPointerMove, { passive: true });
    }
    this.updateParallax();
  }

  onPointerMove(event) {
    const x = event.clientX / window.innerWidth - 0.5;
    const y = event.clientY / window.innerHeight - 0.5;
    this.floatTargets.forEach((el, index) => {
      const intensity = 1 + (index % 3) * 0.35;
      const axis = String(el.dataset.floatAxis || "xy").toLowerCase();
      const tx = axis === "y" ? 0 : x * 8 * intensity;
      const ty = axis === "x" ? 0 : y * 8 * intensity;
      el.style.setProperty("--float-x", `${tx.toFixed(2)}px`);
      el.style.setProperty("--float-y", `${ty.toFixed(2)}px`);
    });
  }

  updateParallax() {
    if (!this.parallaxTargets.length) return;
    const viewportMid = window.innerHeight / 2;
    this.parallaxTargets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      const distance = rect.top + rect.height / 2 - viewportMid;
      const offset = Math.max(-14, Math.min(14, distance * -0.04));
      el.style.setProperty("--parallax-y", `${offset.toFixed(2)}px`);
    });
  }
}
